import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AppComponent } from '../../app.component';
import { AppMainComponent } from 'src/app/app.main.component';
import { TranslateService } from '@ngx-translate/core';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls :['./app.menu.component.scss'],
    animations: [
        trigger('inline', [
            state('hidden', style({
                height: '0px',
                overflow: 'hidden'
            })),
            state('visible', style({
                height: '*',
            })),
            state('hiddenAnimated', style({
                height: '0px',
                overflow: 'hidden'
            })),
            state('visibleAnimated', style({
                height: '*',
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppMenuComponent implements OnInit {
    userName:string;
    gender:string;
    image:string;
    model: any[];
    loading=false;
    _errorMessage:string=''; 
  get errorMessage():string
  {
    return this._errorMessage;
  }
  set errorMessage(value:string)
  {
   this._errorMessage = value;
   this.messageService.add({severity: 'error', summary: 'Error', detail:this._errorMessage, life: 2000});
  }

    constructor(private translate:TranslateService , public app: AppComponent, public appMain: AppMainComponent,private httpHelper:HttphelperService,private messageService:MessageService,private router:Router) {
    }

    ngOnInit() {
        this.userName = localStorage.getItem('patientName');
        this.gender = localStorage.getItem('gender') == "1"? "Male" : "Female";
        this.image = localStorage.getItem('Image');
        this.model = [
            {
                label: "History", icon: 'pi icon-history',//'pi pi-fw pi-list',
                items: [
                    {label: "History", routerLink: ['history']} //, icon: 'pi icon-history'
                ]
            },
            {
                label: "Requests", icon: 'pi icon-requests',
                items: [
                    {label: "Requests", routerLink: ['schedule']}
                ]
            }
        ];
        this.translateItems( this.model);
    }
    signOut():void
  {
    var url = "api/Account/SignOut";    
    this.httpHelper.getRequest(url,true).subscribe({
      next: res => {
            if(res.Success)
            {              
              localStorage.clear();
              this.router.navigate(['/login']);
            }
            else
            {
               this.errorMessage = res.Message;
            }
         },
         error:err => this.errorMessage = err
    });
  }  
  changePassword():void
  {
    this.router.navigate(['/changepassword']);
  }
    onMenuClick(event) {
        var label = event.currentTarget.innerText;
        if(label == "الحجوزات" || label == "Requests"){
            this.router.navigate(['/schedule']);
        }else if(label == "الزيارات السابقه" || label == "History"){
            this.router.navigate(['/history']);
        }
        //this.appMain.onMenuClick(event);
    }
    translateItems(items:any[]){
        for(let i=0; i<items.length; i++){
            this.translate.get(items[i].label).subscribe(res=>{
                items[i].label = res;
                if(items[i].items != undefined){
                    this.translateItems(items[i].items);
                }
            })
        }
    }
}
